import api from "@/lib/api";

// CREATE
export const createNews = async (payload) => {
  const res = await api.post("/news/create", payload);
  return res.data;
};

// GET ALL
export const getAllNews = async () => {
  const res = await api.get("/news/all");
  return res.data;
};

// GET BY ID
export const getNewsById = async (news_id) => {
  const res = await api.get(`/news/${news_id}`);
  return res.data;
};

// DELETE
export const deleteNews = async (news_id) => {
  const res = await api.post(`/news/delete/${news_id}`);
  return res.data;
};

export const getDropDownFirms=async()=>{
    const res = await api.get("/prop-firms/dropdown");
    return res.data;
}


// UPDATE (add when backend is ready)
export const updateNews = async (payload) => {
  const res = await api.post(`/news/update`, payload);
  return res.data;
};